var map = {
	"./PeriodicNewTermAmount.eneco.nl-NL.json": [
		97817,
		7817
	],
	"./PeriodicNewTermAmount.oxxio.nl-NL.json": [
		13684,
		3684
	],
	"./PeriodicNewTermAmount.woonenergie.nl-NL.json": [
		85591,
		5591
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 95974;
module.exports = webpackAsyncContext;